import { store, getContext } from '@wordpress/interactivity';

store( "gt/asterio/login-shortcut", {
    actions:{
      initLoginShortcut: function(){

            const options = store('gt/asterio').state.options;
            
            astJQuery(document).ready(function ($) {
              // dans le cas ou on passe une surcharge de la navigation dans le template
              // var navOverride = new URL(location.href).searchParams.get("navOverride");
              var navOverride = null;
              try {
                var query = astParseUrlQuery(location.href);
                if (query && query.navOverride) {
                  navOverride = JSON.parse(query.navOverride);
                }
              } catch (e) {
                if (window.console) window.console.error("Error in navoverride parameter: " + e);
              }
            
              // le plugin de message doit Ãªtre le premier initialisÃ©
              $('#be-messages').ModuleMessage({
                // pas besoin de kmlCode quand on a un seul pool dÃ©fini, ou qu'il
                // est dÃ©fini dans l'url principale. Idem pour tous les autres modules
                //clientCode : "xxx"
                navOverride: navOverride,
                onlineService : !!ONLINE_SERVICE,
              });
            
              var isSmartphone = ModuleManager.prototype.isSmartphoneSize();
            
              var popUpOptions = {
                show: {effect: "slide", duration: 500, direction: "up"},
                modal: false,
                dialogClass: 'visible-dialog-close-button-on-mobile dialog-as-panel full_screen_on_mobile'
              };
            
              var w = $(window).width();
              var h = $(window).height();
            
              //la dialog contenant le cart peut etre grande si beaucoup de rÃ©servation, dans ce cas on lui donne une maxheight, et on l'append
              //au main-wrapper pour bien que le footer reste en bas si elle venait a dÃ©passer
              //Remarque : 64 est la taille du header
              var cartDialogOptions = $.extend({}, popUpOptions, {maxHeight: (h - 64), appendTo: '.main-wrapper'});
              var loginDialogOptions = $.extend({}, popUpOptions);
            
              $.extend(loginDialogOptions, {
                position: {my: "center top", at: "center bottom", of: "#login_shortcut", collision: 'fit'},
                minWidth: 350,
                maxWidth: 414
              });
            
              $.extend(cartDialogOptions, {
                position: {my: "center top", at: "center bottom", of: "#cart_shortcut", collision: 'fit'},
                minWidth: 350,
                maxWidth: 414
              });
            
              var urlParams =  window.astParseUrlQuery(location.href);

              $("#login_shortcut").ModuleLogin({
                refreshOnLogin: "true",
                messageHandler: $('#be-messages'),
                popupDisplay: true,
                popupOptions: loginDialogOptions,
                avoidBodyScrollWhenDialogOpened: isSmartphone ? true : false,
                highlightFieldLabelOnFocus: true,
                spaceUrl: options.account_page,
                accountCreationUrl: options.account_page + '?gt=create',
                accountEditionUrl: options.account_page + '?editionMode=true',
                passwordEditionUrl: options.account_page + '?gt=passwordreset',
                'sqs.loadtemplatedone': function (event, data) {
                  if (!data.data.loggedIn) {
                    $('.ModuleLogin_dialog.sqs_module_dialog').removeClass('visible-dialog-title');
                  }
                  else if (data.data.loggedIn == true) {
                    //on veut afficher le nom de la personne connectÃ© en titre de la  dialog, pour cela on ajoute la classe  visible-dialog-title qui
                    //permet d'afficher le titre de la dialog
                    //C'est au serveur de spÃ©cifier la valeur du titre en placant l'attribut dialogTitle en reponse au load du template
                    $('.ModuleLogin_dialog.sqs_module_dialog').addClass('visible-dialog-title');
                  }
                }
              });
            
              var languageDialogOptions = $.extend({}, popUpOptions);
            
              $.extend(languageDialogOptions, {
                position: {my: "center top", at: "center bottom", of: "#language_shortcut", collision: 'fit'},
                width: 140,
              });
            
              
            
              $('#login_shortcut').on('sqs.dialogopening', function () {
                $('.sqs-opened-dialog').find('.ui-dialog-content').dialog('close');
              });
            
              $('body').on('click', '.sqs-dialog-btn', function () {
                return false;
              });
            
              $('body').on('click', '.sqs-opened-dialog', function (e) {
                e.stopPropagation();
              });
            
              $('body').on('click', function () {
                $('.sqs-opened-dialog').find('.ui-dialog-content').dialog('close');
              });
            });
                          
        }
    }
  } );
